import Alert from 'ui/Alert';
import Link from 'ui/Link';

import {
  supportedB2BCountryOptions,
  supportedB2CCompanyCountries,
} from '../../constants';
import { PatchedTeamRequestCountry } from '../../generated-api';

type Props = {
  country: PatchedTeamRequestCountry;
};

const PersonalCountryNotSupportedBanner: React.FC<Props> = ({ country }) => {
  const getCountryName = (c: PatchedTeamRequestCountry) =>
    supportedB2BCountryOptions.find((option) => option.value === c)?.label;

  const supportedB2CCountryNames = supportedB2CCompanyCountries
    .map(getCountryName)
    .join(', ');

  return (
    <Alert
      status="error"
      title={`Personal use not supported in ${getCountryName(country)}`}
    >
      Sorry, for personal use we offer SankeyArt only to users based in{' '}
      {supportedB2CCountryNames}.{' '}
      <Link href="mailto:support@sankeyart.com" variant="subtle" isExternal>
        Send us an email
      </Link>{' '}
      to get informed when we'll offer SankeyArt for personal use in{' '}
      {getCountryName(country)}.
    </Alert>
  );
};

export default PersonalCountryNotSupportedBanner;
